import React, { useState } from 'react';
import PropTypes from "prop-types";

import CommonSwapIcon from 'components/common/link-elements/CommonSwapIcon';

import './CommonLinkContainer.css';

function CommonLinkContainer(props) {
  const {
    linkItem,
    headerContent,
    expandedContent,
    allowExpand,
    patchLinkFunction,
  } = props;

  const [openDetails, setOpenDetails] = useState(linkItem.is_expanded_in_dashboard);

  return (
    <div className="common-link-container__component">
      {/* Header Wrapper */}
      <div className={`header-wrapper${(allowExpand && openDetails) ? ' expanded' : ''}`}>
        <div className="swap-icon">
          <CommonSwapIcon />
        </div>
        {headerContent}
      </div>

      {/* Expanded Wrapper */}
      {allowExpand && openDetails &&
        <div className="expanded-wrapper">
          {expandedContent}
        </div>
      }

      {/* Arrow Wrapper */}
      {allowExpand &&
        <div
          className="arrow-wrapper"
          onClick={() => {
            setOpenDetails(!openDetails);
            if (patchLinkFunction) {
              const form = new FormData();
              form.append('is_expanded_in_dashboard', !openDetails);
              patchLinkFunction(linkItem.id, form);
            }
          }}
          role="button"
          tabIndex={-1}
        >
          <div className={`icon${openDetails ? ' up' : ' down'}`} />
        </div>
      }
    </div>
  );
};

CommonLinkContainer.propTypes = {
  patchLinkFunction: PropTypes.func,
  linkItem: PropTypes.object.isRequired,
  headerContent: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]),
  expandedContent: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]),
  allowExpand: PropTypes.bool,
};

CommonLinkContainer.defaultProps = {
  patchLinkFunction: null,
  headerContent: null,
  expandedContent: null,
  allowExpand: null,
};

export default CommonLinkContainer;
